import { FuseAnimate } from '@fuse';
import _ from "@lodash";
import { Icon, List, ListItem, ListItemText, Paper, withStyles } from '@material-ui/core';
import classNames from 'classnames';
import React, { Component } from 'react';
import { MdFormatListBulleted } from 'react-icons/md';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as Actions from './Store/Actions/EmpresaPessoaFormularioActions';

const styles = theme => ({
    listItem: {
        cursor: 'pointer',
        color: theme.palette.text.primary,
        textDecoration: 'none!important',
        height: 40,
        width: 'calc(100% - 16px)',
        borderRadius: '0 20px 20px 0',
        paddingLeft: 24,
        paddingRight: 12,
        '&.active': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText + '!important',
            pointerEvents: 'none',
            '& .list-item-icon': {
                color: 'inherit'
            }
        }
    }
});

class EmpresaPessoaFormularioSidebarContent extends Component {

    render() {
        const { classes, formularios, selected } = this.props;

        return (
            <div className="p-16 lg:p-24 lg:pr-4">
                <FuseAnimate animation="transition.slideLeftIn" delay={200}>
                    <Paper style={{ maxHeight: '30%', overflow: 'auto' }} elevation={1} className="rounded-8">
                        <List>
                            <ListItem
                                id={"ListItem_All"}
                                className={classNames(classes.listItem, _.isNull(selected) && "active")}
                            >
                                <MdFormatListBulleted className="list-item-icon text-16" color="action" />
                                <ListItemText
                                    className="truncate pr-0"
                                    primary='Todos'
                                    disableTypography={true}
                                    onClick={(ev) => {
                                        ev.stopPropagation();
                                        this.props.changeSelected(null);
                                    }}
                                />
                            </ListItem>
                            {formularios ? formularios.map(item => (
                                <ListItem
                                    id={"ListItem_" + item.id}
                                    className={classNames(classes.listItem, (!_.isNull(selected) && selected.id === item.id) && "active")}
                                >
                                    <Icon className="list-item-icon text-16" color="action">{item.icon}</Icon>
                                    <ListItemText
                                        className="truncate pr-0"
                                        primary={item.descricao}
                                        disableTypography={true}
                                        onClick={(ev) => {
                                            ev.stopPropagation();
                                            this.props.changeSelected(item);
                                        }}

                                    />
                                </ListItem>
                            )) : ''}

                        </List>
                    </Paper>
                </FuseAnimate>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ list: Actions.list, }, dispatch);
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(null, mapDispatchToProps)(EmpresaPessoaFormularioSidebarContent)));
